import React, { useEffect, useState } from "react";
import { useFetch } from "../../../../../hooks/useFetch";
import { useAppStore } from "../../../../../stores/RootStore";
import { TriggerType } from "../../../../../types/types";
import Spinner from "../../../../../ui/Spinner/Spinner";
import TriggerSettingsTab from "./tabs/TriggerSettingsTab";


const TriggerItem = ({ id, closeEditModal }: { id: string; closeEditModal: Function }) => {
  const equipments = useAppStore((store) => store.equipments);

  const [{ response, isLoading, error }, doFetchCurrentItem] = useFetch(`/directories/triggers/${id}`);

  const [loading, setLoading] = useState(true);
  const [currentTrigger, setCurrentTrigger] = useState<TriggerType>();

  useEffect(() => {
    if (!id) {
      return;
    }
    setLoading(true);
    doFetchCurrentItem();
  }, [id]);

  useEffect(() => {
    if (!response) {
      return;
    }
    const responseData = response.data as unknown as TriggerType;
    setCurrentTrigger(responseData);
    setLoading(false);
  }, [response]);

  return loading || equipments == null ? (
    <Spinner />
  ) : (
    <TriggerSettingsTab id={id} currentTrigger={currentTrigger} closeEditModal={closeEditModal} />
  );
};

export default TriggerItem;
